module.exports = __webpack_public_path__ + "img/HU10198014.099433e5.png";